import { CPHeader } from "../../assets";
import { Card } from "../molecules";
import { From } from "../molecules/Card/Card";
import "../../resources/signup.scss";
import { Form } from "../organisms";
import { useNavigate, Link } from "react-router-dom";
import { Button, ButtonHtmlType, ButtonType, Input } from "../atoms";
import { useCallback, useEffect, useState } from "react";
import { SignupType } from "../../constants";
import { post } from "../../utils/request";
import { api, STATUS } from "../../constants/api";
import { message } from "antd";
import { isTokenValid } from "../../utils/token";

export const SignUp = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onClickSignUp = useCallback(
    async (values: SignupType) => {
      try {
        setIsLoading(true);
        const res = await post(api.signup, values);

        if (res?.status === STATUS.CREATED || res?.status === STATUS.SUCCESS) {
          message.success(
            "Account created successfully. Redirecting to login...",
          );
          setTimeout(() => {
            navigate("/login");
          }, 1500);
        }
      } catch {
        message.error(
          "Unable to create account. Please check your details and try again.",
        );
      } finally {
        setIsLoading(false);
      }
    },
    [navigate],
  );

  useEffect(() => {
    const token: string | null = localStorage.getItem("token");
    const isValidToken = isTokenValid(token);
    if (isValidToken) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="cp-signup-page">
      <div className="cp-signup-page__container cp--flex-center">
        <div className="cp-signup-page__container__header cp--flex-center">
          <img src={CPHeader} alt="cp-header-image" />
        </div>

        <div className="cp-signup-page__container__welcome cp--flex-center">
          <h1>Create your account</h1>
          <h2>Fill the details below to start managing your finances.</h2>
        </div>

        <div className="cp-signup-page__container__card">
          <Card from={From.LOGIN}>
            <Form onSubmitForm={onClickSignUp}>
              <Input
                placeholder="Email"
                name="email"
                isRequired={true}
                requiredMessage="This field is required!"
                isEmail={true}
              />
              <Input
                placeholder="Password"
                name="password"
                isRequired={true}
                requiredMessage="This field is required!"
                isPassword={true}
              />
              <Input
                placeholder="First Name"
                name="firstName"
                isRequired={true}
                requiredMessage="This field is required!"
              />
              <Input placeholder="Middle Name" name="middleName" />
              <Input
                placeholder="Last Name"
                name="lastName"
                isRequired={true}
                requiredMessage="This field is required!"
              />
              <Input
                placeholder="Address"
                name="address"
                isRequired={true}
                requiredMessage="This field is required!"
              />
              <Input
                placeholder="Phone Number"
                name="number"
                isRequired={true}
                requiredMessage="This field is required!"
              />
              <Input
                placeholder="About Yourself"
                name="description"
                isTextArea={true}
              />
              <div className="cp-signup-page__container__button cp--flex-center">
                <Button
                  isLoading={isLoading}
                  text="SIGN UP"
                  htmlType={ButtonHtmlType.SUBMIT}
                  type={ButtonType.PRIMARY}
                />
              </div>
              <div className="cp-signup-page__container__sign-up cp--flex-center">
                Already have an account?{" "}
                <Link to="/login">
                  <u>Log In</u>
                </Link>
              </div>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
